import { apiSlice } from "./apiSlice";
import { QUESTION_BANK_SUBJECTS_URL } from "../constants";

export const questionBankSubjectApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Create Question Bank Subject
    createQuestionBankSubject: builder.mutation({
      query: (data) => ({
        url: QUESTION_BANK_SUBJECTS_URL,
        method: "POST",
        body: data,
      }),

      invalidatesTags: ["QuestionBankSubject"],
    }),

    // Get all Question Bank Subjects
    getQuestionBankSubjects: builder.query({
      query: () => ({
        url: QUESTION_BANK_SUBJECTS_URL,
      }),

      providesTags: ["QuestionBankSubject"],

      keepUnusedDataFor: 5,
    }),

    // Get Question Bank Subject Details
    getQuestionBankSubjectDetails: builder.query({
      query: (id) => ({
        url: `${QUESTION_BANK_SUBJECTS_URL}/${id}`,
      }),

      providesTags: ["QuestionBankSubject"],

      keepUnusedDataFor: 5,
    }),

    // Update Question Bank Subject
    updateQuestionBankSubject: builder.mutation({
      query: (data) => ({
        url: `${QUESTION_BANK_SUBJECTS_URL}/${data.subjectId}`,
        method: "PUT",
        body: data,
      }),

      invalidatesTags: ["QuestionBankSubject"],
    }),

    // Delete Question Bank Subject
    deleteQuestionBankSubject: builder.mutation({
      query: (id) => ({
        url: `${QUESTION_BANK_SUBJECTS_URL}/${id}`,
        method: "DELETE",
      }),

      invalidatesTags: ["QuestionBankSubject"],
    }),
  }),
});

export const {
  useCreateQuestionBankSubjectMutation,

  useGetQuestionBankSubjectsQuery,

  useGetQuestionBankSubjectDetailsQuery,

  useUpdateQuestionBankSubjectMutation,

  useDeleteQuestionBankSubjectMutation,
} = questionBankSubjectApiSlice;
